import React from 'react';
import { sessionApi } from '../services/api';
import { formatFileSize, formatTime } from '../utils/helpers';
import './FileList.css';

function FileList({ files, sessionId }) {
  const handleDownload = (fileId, fileName) => {
    const url = sessionApi.getDownloadUrl(sessionId, fileId);
    
    // Create temporary link and trigger download
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (files.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-icon">📭</div>
        <p>Noch keine Dateien vorhanden</p>
      </div>
    );
  }

  return (
    <div className="file-list">
      {files.map((file) => (
        <div key={file.id} className="file-item">
          <div className="file-icon">
            {getFileIcon(file.mimeType)}
          </div>
          <div className="file-info">
            <div className="file-name" title={file.name}>
              {file.name}
            </div>
            <div className="file-meta">
              <span>{formatFileSize(file.size)}</span>
              <span className="separator">•</span>
              <span>{formatTime(file.uploadedAt)}</span>
            </div>
          </div>
          <button
            className="btn btn-primary btn-download"
            onClick={() => handleDownload(file.id, file.name)}
          >
            ⬇️ Download
          </button>
        </div>
      ))}
    </div>
  );
}

// Helper function to get appropriate icon based on MIME type
function getFileIcon(mimeType) {
  if (!mimeType) return '📄';
  
  if (mimeType.startsWith('image/')) return '🖼️';
  if (mimeType.startsWith('video/')) return '🎥';
  if (mimeType.startsWith('audio/')) return '🎵';
  if (mimeType.includes('pdf')) return '📕';
  if (mimeType.includes('zip') || mimeType.includes('rar') || mimeType.includes('7z')) return '📦';
  if (mimeType.includes('word') || mimeType.includes('document')) return '📝';
  if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) return '📊';
  if (mimeType.includes('powerpoint') || mimeType.includes('presentation')) return '📽️';
  if (mimeType.includes('text/')) return '📄';
  
  return '📄';
}

export default FileList;
